export default "__VITE_ASSET__D6dbuZsc__"